<template>
    <div class="main">
        <global-tag>
            <span slot="title">废品站</span>
            <div class="search" slot="search">
                <el-form label-width="120px" :model="queryInfo">
                    <div class="searchBox">
                        <div class="content">
                            <el-row>
                                <el-col :span="5">
                                    <el-form-item label="学校名称：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.name"
                                            style="width: 100%"
                                            placeholder="请输入"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="btn">
                            <el-button type="primary" @click="querySearch" class="searchBtns"
                                >查询</el-button
                            >
                        </div>
                    </div>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button
                    type="success"
                    class="button openBtns"
                    size="mini"
                    @click="addServices('新增', 'add')"
                    >新增</el-button
                >
                <el-button
                    type="primary"
                    class="button downOutBtns"
                    size="mini"
                    @click="createExcel"
                    >导出</el-button
                >
                <div style="display: none">
                    <input @change="fileChange" id="speechUpload" type="file" />
                </div>
                <label for="speechUpload" class="labelImportBtn inDwonBtns">
                    <span>导入</span>
                </label>
                <el-button
                    type="danger"
                    class="button"
                    size="mini"
                    @click="deleteItem"
                    >删除</el-button
                >
                <a @click="createExcel1" target="_blank" class="domModel modelDownds"
                    >下载模板</a
                >
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="reset"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="序号"></el-checkbox
                                        ><br />
                                        <el-checkbox label="学校"></el-checkbox
                                        ><br />
                                        <el-checkbox label="备注"></el-checkbox
                                        ><br />
                                        <el-checkbox label="地址"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="标准地址"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="点位坐标"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="创建时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="创建人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                ref="multipleTable"
                @row-click="openDetails"
                @selection-change="handleSelectionChange"
                :header-cell-style="{
                    background: '#e6e6e6',
                    color: '#000',
                }"
                border
            >
                <el-table-column
                    type="selection"
                    width="55"
                    @selection-change="handleSelectionChange"
                ></el-table-column>
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="名称"
                    align="center"
                    prop="name"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '学校'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="备注"
                    align="center"
                    prop="remark"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '备注'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="地址"
                    align="center"
                    prop="location"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="标准地址"
                    align="center"
                    prop="address"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '标准地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="点位坐标"
                    align="center"
                    prop="counts"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '点位坐标'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span
                            >{{ scope.row.longitude }},{{
                                scope.row.latitude
                            }}</span
                        >
                    </template>
                </el-table-column>

                <el-table-column
                    label="创建时间"
                    align="center"
                    prop="createDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑时间"
                    align="center"
                    prop="updateDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="创建人"
                    align="center"
                    prop="createPersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑人"
                    align="center"
                    prop="updatePersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    label="操作"
                    align="center"
                    width="280px"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div>
                            <span
                                @click="addServices('查看', scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >查看</span
                            >
                            <span
                                @click="addServices('编辑', scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >编辑</span
                            >
                            <span
                                @click="seeMap(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >查看地图定位</span
                            >
                            <!-- <span
                @click="deleteItem(scope.row)"
                style="margin-right: 12px; cursor: pointer"
                >删除</span
              > -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-size="pageOne.pageSize"
                :current-page.sync="pageOne.pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOne.total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <add-service
            v-if="serviceState"
            :openData="serviceInfo"
            @cancleService="cancleService"
        ></add-service>
        <map-info
            v-if="mapState"
            :openData="mapInfo"
            @cancleService="cancleService"
        ></map-info>
    </div>
</template>
<script>
import globalTag from "../../../../components/globalTag"
import addService from "./components/addService"
import mapInfo from "@/components/mapInfo"
import request from "@/utils/request.js"
export default {
    name: "serviceMange",
    inject: ["reload"], //注入
    components: { globalTag, addService, mapInfo },
    data() {
        return {
            selectedData: [],
            mapState: false,
            mapInfo: {},
            signState: false,
            signInfo: {},
            sexOptions: [
                { value: "0", label: "男" },
                { value: "1", label: "女" },
            ],
            pageOne: { total: 0, pageSize: 10, pageNo: 1 },
            tableData: [],
            queryInfo: {},
            serviceState: false,
            serviceInfo: {},

            tempTableChekbox: [
                "序号",
                "学校",
                "备注",
                "地址",
                "标准地址",
                "点位坐标",

                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "学校",
                "备注",
                "地址",
                "标准地址",
                "点位坐标",

                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        // 查看定位
seeMap(row) {
  this.mapState = true
  this.mapInfo = row
  this.mapInfo.state = true
},
        // 走访处理
        goSee(row) {
            this.signState = true
            this.signInfo = { id: row.id, state: true }
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                type: 1,
                name: this.queryInfo.name,
            }
            this.$http
                .request({
                    url: "/ypt/admin/marketSupervision/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        if (res.content.list.length > 0) {
                            res.content.list.forEach((item) => {
                                item.hasChagned =
                                    Number(item.counts) - Number(item.stock)
                            })
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },

        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        // 取消新增、编辑、查看
        cancleService(state) {
            this.serviceState = false
            this.mapState = false
            this.signState = false
            if (state == true) {
                this.getList()
            }
        },

        // 新增\编辑\查看
        addServices(title, row) {
            this.serviceState = true

            this.serviceInfo = {}
            this.serviceInfo = {
                title: title,
                id: title == "新增" ? "" : row.id,
                state: true,
            }
        },

        // 页面刷新
        reset() {
            this.reload()
        },
        // 搜索
        querySearch() {
            this.getList()
        },
        //导出excel
        createExcel() {
            this.request2({
                url: "/ypt/admin/marketSupervision/info/downloadExcel",
                method: "POST",
                excel: true,
                data: {
                    type: 1,
                },
                responseType: "blob",
            }).then((res) => {
                console.log("adsasd")
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "废品站信息.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出表格成功")
                }
            })
            // const res = await request2({
            //     url: "/ypt/admin/section/info/export",
            //     method: "POST",
            //     data: {},
            //     responseType: "blob",
            // })
            // const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            // const fileName = "楼栋信息.xls"
            // const linkNode = document.createElement("a")

            // linkNode.download = fileName //a标签的download属性规定下载文件的名称
            // linkNode.style.display = "none"
            // linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            // document.body.appendChild(linkNode)
            // linkNode.click() //模拟在按钮上的一次鼠标单击

            // URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            // document.body.removeChild(linkNode)
        },
        //下载模板
        createExcel1() {
            this.request2({
                url: "/ypt/admin/marketSupervision/info/downloadExcel",
                method: "POST",
                excel: true,
                data: {
                    type: 0,
                },
                responseType: "blob",
            }).then((res) => {
                console.log("adsasd")
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "机构信息.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出表格成功")
                }
            })
        },
        // 导入
        async fileChange(event) {
            console.log(event)
            const file = event.target.files[0]
            console.log(file)
            const personType = "1"
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            }
            let formData = new FormData()
            formData.type = 1
            formData.append("personType", personType)
            console.log(formData)
            formData.append("file", file)
            let result = await this.$http.post(
                "/ypt/admin/marketSupervision/info/excel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code == 200) {
                this.$message.success(result.message)
                this.getList()
            } else {
                this.$message.warning(result.message)
            }
        },
        handleSelectionChange(data) {
            this.selectedData = data
            console.log(this.selectedData)
        },
        // 行点击选中
        openDetails(row, event, column, cell) {
            this.$refs.multipleTable.toggleRowSelection(row)
            this.row = row
            this.column = column
        },
        deleteItem() {
            var val = this.selectedData
            if (val.length > 0) {
                this.$confirm("确认永久删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        val.forEach(function (item, index) {
                            request({
                                url:
                                    "/ypt/admin/marketSupervision/info/deleteById",
                                method: "POST",
                                data: { id: item.id },
                            })
                        })
                    })
                    .then(() => {
                        this.reset()
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })
                    })
            } else {
                this.$confirm("请选择要删除的项。", "提示")
            }
            this.$refs.multipleTable.clearSelection()
        },
    },
}
</script>
<style lang="less" scoped>
.searchBox {
    display: flex;
    .content {
        flex: 1;
    }
}
/deep/.table_title {
    margin-top: 15px !important;
}
/deep/.btn_group {
    margin-top: 0px !important;
}
.button {
    margin-bottom: 4px;
}
.labelImportBtn,
.domModel {
    background: orange;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 10px;
    font-size: 12px;
    padding: 0 17px;
    color: #fff;
    line-height: 28px;
    display: inline-block;
}
.domModel {
    background: green;
    text-decoration: none;
}
.operBtn {
    cursor: pointer;
    margin-left: 10px;
}
</style>